export default __webpack_public_path__ + "static/media/message.4f60a2ef.svg";